import axios from "axios";

// Determine API URL based on environment
const getApiUrl = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const url = isProduction
    ? process.env.REACT_APP_API_PROD_URL
    : process.env.REACT_APP_API_URL;

  if (!url) {
    console.error(
      `[api.js] WARNING: ${isProduction ? "REACT_APP_API_PROD_URL" : "REACT_APP_API_URL"} is not defined in your .env file. Falling back to http://localhost:5000`,
    );
    return "http://localhost:5000";
  }

  // Strip trailing slash to avoid double-slash in baseURL
  return url.replace(/\/$/, "");
};

const api = axios.create({
  baseURL: `${getApiUrl()}/api`,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT token to every request if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ql_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth-middleware rejections (expired/invalid JWT). Deliberately narrow so
// business 401s like "Current password is incorrect." don't log the user out.
const AUTH_FAILURE_MESSAGE = /^(Not authorized|User not found)/;

// Global response error interceptor — logs detail to console for debugging
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message || error.message;
    console.error(
      `[api.js] ${error.config?.method?.toUpperCase()} ${error.config?.url} → ${status}: ${message}`,
    );
    if (
      status === 401 &&
      AUTH_FAILURE_MESSAGE.test(message) &&
      localStorage.getItem("ql_token")
    ) {
      localStorage.removeItem("ql_token");
      localStorage.removeItem("ql_user");
      window.location.assign("/?session=expired");
    }
    return Promise.reject(error);
  },
);

export default api;
